module.exports = __webpack_public_path__ + "fonts/Inter-400-latin-ext48.2685934.woff2";